module.exports = __webpack_public_path__ + "static/media/ic-devices.5870a771.svg";